module.exports = __webpack_public_path__ + "img/Flag_of_Swaziland_1894.6ef90e05.svg";